import styled from 'styled-components'

export const StyledArbitrationRequestSection = styled.div`
  .mileage-field {
    width: 100%;
    flex-direction: column;
  }

  .arbitration-textarea {
    width: 100%;
    display: flex;
    padding: 0 45px;
    margin-bottom: 4px;
  }

  .arbitration-textarea-form {
    width: 100%;
  }

  .char-counter {
    font-size: 12px;
    color: #6c757d;
    text-align: right;
    margin-top: 2px;
  }

  .arbitration-textarea textarea {
    width: 100%;
    padding: 5px 8px;
  }

  .arbitration-textarea label {
    min-width: 170px;
    font-weight: 600;
    line-height: 60px;
    margin: 0;
  }

  .warning-label {
    margin-left: 190px;
    display: block;
    font-size: 12px;
  }

  .warning-label::before {
    content: '!';
    color: red;
    margin-right: 5px;
  }

  .updated-attachment-field {
    width: 100%;
    display: flex;
    padding: 0 45px;
    margin-bottom: 4px;

    label {
      min-width: 170px;
      font-weight: 600;
      line-height: 30px;
    }

    .row {
      width: 100%;
      padding-top: 1px;
    }
  }

  .updated-attachment-file-name {
    max-height: 70px;
    overflow-x: hidden;
  }

  .text-truncate-filename {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }

  .arbitration-attachment {
    display: flex;
    padding: 0 45px;
    margin-bottom: 8px;
  }

  .arbitration-attachment-label {
    min-width: 170px;
    font-weight: 600;
    line-height: 30px;
    margin: 0;
  }

  .file-notes-label {
    font-size: 12px;
    padding-top: 8px;
  }

  .file-uploader-container {
    display: block;
    width: 100%;
    padding-left: 215px;
    padding-right: 45px;
  }

  @media (max-width: 1200px) {
    .arbitration-textarea {
      padding: 0 20px;
    }

    .arbitration-textarea textarea {
      margin: 0;
      margin-right: 15px;
    }

    .arbitration-attachment {
      padding: 0 20px;
    }

    .file-uploader-container {
      padding-right: 20px;
      padding-left: 185px;
    }
  }

  @media (max-width: 768px) {
    .arbitration-textarea,
    .arbitration-attachment,
    .updated-attachment-field {
      display: block;
    }

    .arbitration-textarea label {
      line-height: 30px;
    }

    .arbitration-textarea textarea {
      margin: 0;
    }

    .warning-label {
      padding: 0 20px;
      margin-left: 0;
    }

    .file-uploader-container {
      padding: 0 20px;
    }
  }
`
